import { Draw, Interaction, Modify, Select, Snap } from 'ol/interaction'
import { Injectable } from '@angular/core'
import VectorSource from 'ol/source/Vector'
import { Options as DrawOptions } from 'ol/interaction/Draw'
import { Options as SelectOptions } from 'ol/interaction/Select'
import { Map } from 'ol'
import { Layer } from 'ol/layer'
import BaseLayer from 'ol/layer/Base'
import VectorLayer from 'ol/layer/Vector'

@Injectable({
    providedIn: 'root',
})
export class OpenLayersMapService {

    addDrawingPolygonToMap(id: string, map: Map, options: DrawOptions): Draw {
        const draw = new Draw(options)
        draw.set('id', id)
        map.addInteraction(draw)

        return draw
    }

    addModifyingToMap(id: string, map: Map, source: VectorSource<any>): Modify {
        const modify = new Modify({ source: source })
        modify.set('id', id)
        map.addInteraction(modify)

        return modify
    }

    addSelectToMap(id: string, map: Map, options: SelectOptions): Select {
        const select = new Select(options)
        select.set('id', id)
        map.addInteraction(select)

        return select
    }

    addSnappingToMap(id: string, map: Map, source: VectorSource<any>): Snap {
        const snap = new Snap({ source: source })
        snap.set('id', id)
        map.addInteraction(snap)

        return snap
    }

    existsLayerByName(layerName: string, map: Map): boolean {
        return map.getLayers().getArray()
            .some(layer => layer.get('name') === layerName)
    }

    getInteractionById(id: string, map: Map): Interaction {
        let result: Interaction

        map.getInteractions().forEach(interaction => {
            if (interaction && interaction.get('id') === id) {
                result = interaction
            }
        })

        return result
    }

    getVectorLayerByName(layerName: string, map: Map): BaseLayer {
        return map?.getLayers().getArray().find(layer => layer.get('name') === layerName)
    }

    getVectorSourceForLayerByName(layerName: string, map: Map): VectorSource<any> {
        return (this.getVectorLayerByName(layerName, map) as VectorLayer<any>)?.getSource()
    }

    setVectorSourceForLayerByName(layerName: string, map: Map, source: VectorSource<any>): void {
        (this.getVectorLayerByName(layerName, map) as VectorLayer<any>)?.setSource(source)
    }

    getVectorSourceFromLayer(layer: Layer<VectorSource>): VectorSource {
        return layer?.getSource()
    }

    removeLayerByName(layerName: string, map: Map): void {
        map.getLayers().getArray()
            .filter(layer => layer.get('name') === layerName)
            .forEach(layer => map.removeLayer(layer))
    }

    removeInteractionByIdFromMap(id: string, map: Map): void {
        const interactionToRemove = this.getInteractionById(id, map)

        if (interactionToRemove) {
            map.removeInteraction(interactionToRemove)
        }
    }

    setLayerVisibility(layerName: string, map: Map, value: boolean): void {
        (this.getVectorLayerByName(layerName, map) as VectorLayer<any>)?.setVisible(value)
    }

    switchLayerVisibility(layerName: string, map: Map): void {
        map.getLayerGroup().getLayers().forEach((layer) => {
            if (layer.get('name') === layerName) {
                layer.setVisible(!layer.getVisible())
            }
        })
    }
}